var TESLA_HEADER_API = 'https://www.tesla.com/api/tesla/header/v1_1';
var DEFAULT_COUNTRIES_PER_REGION = {
  'North America': ['United States'],
  Europe: ['Other Europe'],
  'Middle-East': ['UAE'],
  'Asia/Pacific': ['Australia']
};
var DEFAULT_COUNTRIES_SHORT_PER_REGION = {
  'North America': ['US'],
  Europe: ['EU'],
  'Middle-East': ['UAE'],
  'Asia/Pacific': ['CN']
};

export { DEFAULT_COUNTRIES_PER_REGION, DEFAULT_COUNTRIES_SHORT_PER_REGION, TESLA_HEADER_API };
